<script setup>
import { onMounted } from 'vue';
import Layout from "../Components/Layout.vue";

const props = defineProps({
    botUsername: String,
});

const botLink = 'https://t.me/' + props.botUsername;

const openUrl = () => {
    Telegram.WebApp.openLink(botLink);
}

onMounted(() => {
    Telegram.WebApp.MainButton.hide();
    Telegram.WebApp.BackButton.hide();
});
</script>

<template>
    <Layout>
        <div class="p-4 space-y-4 bg-tgThemeSecondaryBgColor">
            <h1 class="text-2xl font-semibold">Запустите бота, чтобы начать:</h1>

            <div class="p-6 bg-tgThemeSectionBgColor rounded-lg">
                👉 <button @click="openUrl" class="text-tgThemeLinkColor">{{ botLink }}</button>
            </div>
        </div>
    </Layout>
</template>
